if (!customElements.get('adev-main-collection-page')) {
    customElements.define('adev-main-collection-page', class adevMainCollectionPage extends HTMLElement {
        constructor() {
            super();
        }

        init(){
            const paginationWrap = this.querySelector('[data-adev-pagination="wrap"]:not(.adev-init)');
            if (!paginationWrap) return;

            if (this.InfiniteScrollInstance) {
                this.InfiniteScrollInstance.destroy();
                this.classList.remove('adev--infinite-scroll-enabled');
                paginationWrap.classList.remove('adev-init');
            }

            const grid = this.querySelector('[data-adev-main-collection-page="product-grid"]');

            const prevButton = paginationWrap.querySelector('[data-adev-pagination="prev"]');
            const nextButton = paginationWrap.querySelector('[data-adev-pagination="next"]');
            
            if (nextButton) {
                this.InfiniteScrollInstance = new InfiniteScroll( grid, {
                    path: '[data-adev-pagination="next"]',
                    append: '[data-adev-main-collection-page="product-col"]',
                    history: false,
                });

                this.classList.add('adev--infinite-scroll-enabled');
                paginationWrap.classList.add('adev-init');
            }
        }

        connectedCallback() {
            this.init();

            document.addEventListener('adev:product-grid:updated', () => {
                this.init();
            });
        }

        disconnectedCallback() {
            if (this.InfiniteScrollInstance) {
                this.InfiniteScrollInstance.destroy();
            }
        }

    });
}